import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/devtools/member-lookup")({
  component: lazyRouteComponent(() => import("./+MemberLookup")),
  head: () => ({ meta: seo({ title: "Member Lookup" }) }),
});
